import React, { useContext, useEffect, useState } from "react"
import OnDemandTypeSelector from "../../../OnDemandTypeSelector"
import DatePicker from "../../../Datepicker"
import { addDays, addMonths, parse } from "date-fns"
import minDateGap from "../../../../utils/minDateGap"
import OnDemandTimePicker from "../../../OnDemandTypeSelector/TimePicker"
import { SpaceProfileContext } from "../../context"

const customHolidays = [
  new Date(2021, 7, 8),
  new Date(2021, 7, 9),
  new Date(2021, 7, 10),
  new Date(2021, 7, 11),
  new Date(2021, 7, 12),
  new Date(2021, 7, 13),
  new Date(2021, 7, 14),
  new Date(2021, 7, 15),
  new Date(2021, 7, 16),
  new Date(2021, 7, 17),
  new Date(2021, 7, 18),
  new Date(2021, 7, 19),
  new Date(2021, 7, 20),
  new Date(2021, 7, 21),
  new Date(2021, 7, 22),
]

const OndPicker = () => {
  const {
    commonData: {
      contextDate,
      contextEndDate,
      location,
      startTime,
      endTime,
      isDaily,
      holidays = [],
    },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  const [customHolidays, setCustomHolidays] = useState([])

  useEffect(() => {
    if (location.customHolidays && location.customHolidays.length > 0) {
      // add them
      setCustomHolidays(
        location.customHolidays.map(({ date }) => {
          const dt = date.split("T")[0]
          if (!dt) return null
          return parse(dt, "yyyy-MM-dd", new Date())
        })
      )
    }
  }, [location.customHolidays])

  const clearFilters = () => {
    if (typeof window !== "undefined" && window.innerWidth >= 1200) {
      setValue({ onDemandStep: 0 })
    }
  }

  const setDates = (value) => {
    if (value.length === 2) {
      const [start, end] = value
      setValue({
        contextDate: start,
        contextEndDate: end,
      })
      if (start && end) clearFilters()
    } else {
      setValue({
        contextDate: value,
        contextEndDate: value,
      })
    }
  }

  const toggleDaily = (value) => {
    setValue({
      contextDate: null,
      startTime: "",
      endTime: "",
      contextEndDate: null,
      optionTotal: 0,
      optionValue: 0,
      optionPrice: 0,
      optionHstValue: 0,
      optionId: "",
      isDaily: value,
      optionData: {},
      filteredOptions: [],
      days: 1,
    })
  }

  return (
    <>
      <OnDemandTypeSelector
        isDaily={isDaily}
        setDaily={() => toggleDaily(true)}
        setHourly={() => toggleDaily(false)}
        className={"mb-3"}
      />
      <DatePicker
        value={contextDate}
        maxDate={addMonths(new Date(), 3)}
        minDate={addDays(new Date(), minDateGap())}
        selected={contextDate}
        setValue={setDates}
        startDate={contextDate}
        endDate={contextEndDate}
        selectsRange={isDaily}
        inline
        excludeDates={
          location &&
          location.id &&
          location.id === "077cd53c-0178-484f-9daf-e1cd1d6869e0"
            ? [...holidays, ...customHolidays]
            : holidays
        }
      />
      {!isDaily && (
        <OnDemandTimePicker
          startDate={contextDate}
          startTime={startTime}
          setStartTime={(value) =>
            setValue({
              startTime: value,
              endTime: "",
              filteredOptions: [],
              optionId: null,
              optionPrice: 0,
              optionValue: 0,
              optionHstValue: 0,
              optionData: { price_per_hour: 0, price_per_day: 0 },
              optionTotal: 0,
              days: 1,
            })
          }
          endTime={endTime}
          setEndTime={(value) => {
            setValue({ endTime: value })
            clearFilters()
          }}
          className={"mt-3 mb-1"}
        />
      )}
    </>
  )
}

export default OndPicker
